import React, { useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { useNavigate, useLocation } from "react-router-dom";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({ inst, handleCancelClick, increment, setInstId }) => {
  const [inst1, setInst1] = useState(inst);
  const [error, setError] = useState(false);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    if (name === "active") {
      inst1.active = e.target.checked;
    } else
      setInst1((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "evaluationinstitute/" + inst1.id + "/",
          inst1,
          {
            signal: controller.signal,
          }
        );
        increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
    setInstId(null);
  };

  return (
    <tr>
      <td>
        <input
          type="text"
          name="title"
          value={inst1.title}
          onChange={handleChange}
          className="form-control"
          id="title"
        />
      </td>
      <td>
        <input
          type="text"
          name="contact_name"
          value={inst1.contact_name}
          onChange={handleChange}
          className="form-control"
          id="contact_name"
        />
      </td>
      <td>
        <input
          type="text"
          name="address"
          value={inst1.address}
          onChange={handleChange}
          className="form-control"
          id="address"
        />
      </td>

      <td>
        <input
          type="text"
          name="tel1"
          value={inst1.tel1}
          onChange={handleChange}
          className="form-control"
          id="tel1"
        />
      </td>
      <td>
        <input
          type="text"
          name="tel2"
          value={inst1.tel2}
          onChange={handleChange}
          className="form-control"
          id="tel2"
        />
      </td>
      <td>
        <input
          type="text"
          name="fax"
          value={inst1.fax}
          onChange={handleChange}
          className="form-control"
          id="fax"
        />
      </td>
      <td>
        <input
          type="email"
          name="email"
          value={inst1.email}
          onChange={handleChange}
          className="form-control"
          id="email"
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          שמירה
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          ביטול
        </button>
      </td>
    </tr>
  );
};

export default Edit;
